module.exports = __webpack_public_path__ + "logo-splash-negro1.png?3624a524d561278fe2b92e9670741aa1";


//////////////////
// WEBPACK FOOTER
// ./images/logo-splash-negro1.png
// module id = 321
// module chunks = 0